const styles = {
  link: {
    textUnderlineOffset: "5px",
  },
  header: {
    fontSize: { xs: 35, lg: 54 },
    fontFamily: "DM Serif Display",
    color: "primary.main",
    mb: 2,
  },
  limitedTime: {
    mt: -2,
  },
};

export default styles;
